import { useEffect, useState } from "react";

/**
 * useScrolled
 * Returns a boolean that flips to `true` once the page scrolls past `threshold`.
 * Reusable across sticky headers, back-to-top FABs, etc.
 *
 * @param {number} threshold - vertical pixels before flipping to true (default 24)
 * @returns {boolean}
 */
export const useScrolled = (threshold = 24) => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () =>
            setScrolled(window.scrollY > threshold);

        handleScroll();
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () =>
            window.removeEventListener("scroll", handleScroll);
    }, [threshold]);

    return scrolled;
};

export default useScrolled;
